import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.$scrollCta = this.$('scroll-cta')[0]
    }

    init() {
        this.pulse();
    }

    pulse() {
        this.$scrollCta.classList.add('-pulse');
        this.timeout = setTimeout(() => {
            this.$scrollCta.classList.remove('-pulse');

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    this.pulse()
                })
            });
        },4000)
    }

    destroy() {
        super.destroy();

        this.timeout && clearTimeout(this.timeout);
    }
}
